import { render, staticRenderFns } from "./CategoriesFilterMobile.vue?vue&type=template&id=fbec7d68&scoped=true&"
import script from "./CategoriesFilterMobile.vue?vue&type=script&lang=js&"
export * from "./CategoriesFilterMobile.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesFilterMobile.vue?vue&type=style&index=0&id=fbec7d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbec7d68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\swag\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbec7d68')) {
      api.createRecord('fbec7d68', component.options)
    } else {
      api.reload('fbec7d68', component.options)
    }
    module.hot.accept("./CategoriesFilterMobile.vue?vue&type=template&id=fbec7d68&scoped=true&", function () {
      api.rerender('fbec7d68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Swag/components/Filters/CategoriesFilterMobile.vue"
export default component.exports